<template>
    <div class="rounded-md bg-sky-50 p-4" v-if="alert">
        <div class="flex">
            <div class="shrink-0">
                <svg class="h-8 w-6 text-sky-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                        clip-rule="evenodd"
                    />
                </svg>
            </div>
            <div class="ml-3">
                <p class="text-md font-regular text-sky-800 leading-8">{{ alert }}</p>
            </div>
            <div class="ml-auto pl-3" v-if="onDismiss">
                <div class="-mx-1.5 -my-1.5">
                    <button
                        type="button"
                        @click="onDismiss()"
                        class="inline-flex rounded-md bg-sky-50 p-1.5 text-sky-500 hover:bg-sky-100 focus:outline-hidden focus:ring-2 focus:ring-sky-600 focus:ring-offset-2 focus:ring-offset-sky-50"
                    >
                        <span class="sr-only">Dismiss</span>
                        <svg class="h-8 w-6" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path
                                d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AlertSuccess',
    props: ['alert', 'onDismiss'],
};
</script>
